import React, {useState} from 'react';
import {
  Menu,
  MenuItem,
} from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import {useAuth} from "../../../../hooks/useAuth";
import {EmailEditModal} from "../../admin/Account/EailEditModal";
import {PasswordEditModal} from "../../admin/Account/PasswordEditModal";
import {ProfileEditModal} from "../../admin/Account/ProfileEditModal";
import useLoading from "../../../../hooks/useLoading";

export const Header: React.FC = () => {
  const { logout } = useAuth();
  const [ showProfileEditModal, setShowProfileEditModal ] = useState<boolean>(false);
  const [ showEmailEditModal, setShowEmailEditModal ] = useState<boolean>(false);
  const [ showPasswordEditModal, setShowPasswordEditModal ] = useState<boolean>(false);
  const withLoading = useLoading();

  return (
    <>
      {showProfileEditModal && (
        <ProfileEditModal
          {...{
            setShowModal: setShowProfileEditModal,
            onSaved: async () => {setShowProfileEditModal(false)},
          }}
        />
      )}
      {showEmailEditModal && (
        <EmailEditModal
          {...{
            setShowModal: setShowEmailEditModal,
            onSaved: async () => {setShowEmailEditModal(false)},
            }}
        />
      )}
      {showPasswordEditModal && (
        <PasswordEditModal
          {...{
            setShowModal: setShowPasswordEditModal,
            onSaved: async () => {setShowPasswordEditModal(false)},
          }}
        />
      )}
      <header className="flex items-center justify-end text-primary border-b-4 border-primary py-2 px-4 h-30">
        <div>
          <Menu
            position="anchor"
            align="end"
            /* eslint-disable-next-line react/jsx-boolean-value */
            arrow={true}
            menuButton={
              <button
                type="button"
                className="flex items-center justify-center w-full rounded-md  px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-50 focus:outline-none"
              >
                <svg width="20" fill="currentColor" height="20" className="text-gray-800"
                     viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1523 1339q-22-155-87.5-257.5t-184.5-118.5q-67 74-159.5 115.5t-195.5 41.5-195.5-41.5-159.5-115.5q-119 16-184.5 118.5t-87.5 257.5q106 150 271 237.5t356 87.5 356-87.5 271-237.5zm-243-699q0-159-112.5-271.5t-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5 271.5-112.5 112.5-271.5zm512 256q0 182-71 347.5t-190.5 286-285.5 191.5-349 71q-182 0-348-71t-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z" />
                </svg>
              </button>
            }
          >
            <MenuItem styles={{ padding: '0'}} className="hover:bg-blue-500 hover:text-white">
              <button
                className="block px-4 py-2 w-full text-sm text-left text-gray-700 hover:bg-blue-500 hover:text-white"
                type="button"
                onClick={() => {
                  setShowProfileEditModal(true);
                }}
              >
                プロフィール変更
              </button>
            </MenuItem>
            <MenuItem styles={{ padding: '0'}} className="hover:bg-blue-500 hover:text-white">
              <button
                className="block px-4 py-2 w-full text-sm text-left text-gray-700 hover:bg-blue-500 hover:text-white"
                type="button"
                onClick={() => {
                  setShowEmailEditModal(true);
                }}
              >
                メールアドレス変更
              </button>
            </MenuItem>
            <MenuItem styles={{ padding: '0'}} className="hover:bg-blue-500 hover:text-white">
              <button
                className="block px-4 py-2 w-full text-sm text-left text-gray-700 hover:bg-blue-500 hover:text-white"
                type="button"
                onClick={() => {
                  setShowPasswordEditModal(true);
                }}
              >
                パスワード変更
              </button>
            </MenuItem>
            <MenuItem styles={{ padding: '0'}} className="hover:bg-blue-500 hover:text-white">
              <button
                className="block px-4 py-2 w-full text-sm text-left text-gray-700 hover:bg-blue-500 hover:text-white"
                type="button"
                onClick={() => withLoading(logout)}
              >
                ログアウト
              </button>
            </MenuItem>
          </Menu>
        </div>
      </header>
    </>
  );
}
